<template>
	<div class="main_messageg" :class="flexs?'on':''">
		<div class="serviceicon" :class="messageFlag?'on':''" @click.stop="messageFlag = !messageFlag">
			<img src="@/assets/images/week_30.png" />
		</div>
		<div class="child" :class="messageFlag?'on':''">
			<div class="head">
				<div>
					<img src="@/assets/images/index_79.png" />
					<span>{{$t('woyaoliuyan')}}</span>
				</div>
				<img src="@/assets/images/index_76.png" @click="call" />
			</div>
			<div class="form">
				<div class="change">
					<input type="text" v-model="message" :placeholder="$t('qingshuruliuyanneirong')" name="" id="" value="" />
					<img src="@/assets/images/send.png" @click="sendmessage" />
				</div>
				<img @click.stop="messageFlag = !messageFlag" src="@/assets/images/next.png" />
			</div>
		</div>
		<div class="fadein_bind" v-if="ServiceContactus">
			<div class="box" style="width: 360px;">
				<div class="head">
					<p>{{$t('contactphone')}}</p>
					<img src="@/assets/images/close_03.png" @click="ServiceContactus = false" class="close" />
				</div>
				<div class="cj" style="text-align: center;">
					<el-button type="primary" icon="el-icon-phone" > +61 08 6243 4609</el-button>
					<img src="@/assets/images/serviceprocesswechat.jpg" style="width: 320px;"/>
					<p style="text-align: center;font-size: 14px;font-weight: bold;color: cadetblue;">{{ $t('qrcodeforservice') }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import {
		Message
	} from 'element-ui';
	import {
		Loading
	} from 'element-ui';
	export default {
		name: 'navbar',
		props: ['flexs','messageFlag'],
		data() {
			return {
				message: '',
				ServiceContactus:false
			}
		},
		computed: {

		},
		methods: {
			call() {
				this.ServiceContactus=!this.ServiceContactus;
				// this.$alert('+61 08 6243 4609', this.$t('contactphone'), {
				// 	confirmButtonText: this.$t('queding'),
				// 	callback: action => {

				// 	}
				// });
			},
			sendmessage() {
				if(!localStorage.getItem('token')) {
					return this.$store.commit("changeLogin", true);
				}
				if(!this.message) {
					return Message(this.$t('qingshuruliuyanneirong'));
				}
				protal.submitRemark({
					remark: this.message
				}).then(res => {
					console.log(res)
					if(res.code == 200) {
						this.message = '';
						this.$message({
							type: 'success',
							message: this.$t('msgsuccess')
						});
					} else {
						this.$message({
							type: 'warning',
							message: this.$t('msgfailed')
						});
					}
				})

			},
		}
	}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/message.vue